.form {
  display: flex;
  flex-direction: column;
  gap: 22px;
}

.error {
  font-size: 14px;
  font-weight: 600;
  color: var(--error);
}
